import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import useScreenWidth from "../../../hooks/useScreenwidth";

const CustomDatagrid = ({
  rows,
  columns,
  CustomNoRowsOverlay,
  getRowId,
  height,
  tHeight = "33em",
  checkRequired = false,
  onCellClick,
  hoverColor = "white",
  onRowClick ,
}) => {
  const [isRowsVisible, setIsRowsVisible] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const screenWidth = useScreenWidth();
  useEffect(() => {
    let timeoutId;

    if (rows && rows.length > 0) {
      setIsRowsVisible(true);
      setShowLoader(false);
    } else {
      timeoutId = setTimeout(() => {
        setIsRowsVisible(false);
        setShowLoader(false);
      }, 2000);
    }

    return () => clearTimeout(timeoutId);
  }, [rows]);

  useEffect(() => {
    setIsRowsVisible(rows && rows.length > 0);
  }, [rows]);

  const dynamicHeight = isRowsVisible
    ? "auto"
    : screenWidth > 1600
    ? "60vh"
    : tHeight;

  const modifiedColumns = columns?.map((column) => ({
    ...column,
    sortable: column?.hasOwnProperty("sortable") ? column.sortable : false,
  }));

  return (
    <Box
      sx={{
        minHeight: tHeight,
        marginBottom: "1.5rem",
        transition: "height 0.3s ease-in-out", // Add smooth height transition
        height: dynamicHeight,
        fontFamily: "Inter",
      }}
    >
      <div
        className={`${isRowsVisible ? "" : "table-div"} h-100 mb-3`}
        style={{ height: isRowsVisible ? "100%" : "0" }}
      >
        <DataGrid
          rows={rows}
          columns={modifiedColumns}
          getRowId={getRowId}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          loading={showLoader}
          onCellClick={onCellClick}
          onRowClick={onRowClick}
          checkboxSelection={checkRequired}
          getRowHeight={height}
          disableRowSelectionOnClick
          hideFooterPagination={false}
          hideFooter
          disableColumnMenu
          className="custom-scrollbar"
          sx={{
            "&.MuiDataGrid-root": {
              border: "none",
              marginTop: "0 !important",
              fontFamily: "Inter",
            },
            "& .MuiDataGrid-cellContent": {
              fontFamily: "Inter !important",
              fontWeight: "500 !important",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "500 !important",
              color: "#6F767E !important",
              fontFamily: "Inter",
            },
            "& .MuiDataGrid-columnHeader:focus": {
              outline: "0",
            },
            "& .MuiDataGrid-columnHeader:focus-within": {
              outline: "0",
            },
            "& .MuiCheckbox-root": {
              color: "#C0C4C9 !important",
            },
            "& .MuiDataGrid-row:hover": {
              background: "white",
            },
            "& .MuiCheckbox-colorPrimary": {
              color: "#C0C4C9 !important",
            },
            "& .MuiDataGrid-virtualScroller": {
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none" /* IE and Edge */,
              "scrollbar-width": "none" /* Firefox */,
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "0px !important",
            },
            overflowX: "hidden",
          }}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          disableColumnFilter
        />
      </div>
    </Box>
  );
};

export default CustomDatagrid;
